export default "__VITE_ASSET__Becsw$u4__"